export default __webpack_public_path__ + "media/images/favicon/cube_light-b8005fd5085eefcae4c5e3bff1de5196.png";